import {
  type DataBindingConnectionConfigByRole,
  type DataBindingControllerConnection,
  type DataBindingRole,
} from '../types'
import { isControllerConnectionWithRole } from './isControllerConnectionWithRole'

export const getControllerConnectionConfig = <Role extends DataBindingRole>({
  connections,
  role,
}: {
  connections: DataBindingControllerConnection[]
  role: Role
}): DataBindingConnectionConfigByRole[Role] => {
  for (let index = 0; index < connections.length; index += 1) {
    const connection = connections[index]
    if (isControllerConnectionWithRole(connection, role)) {
      return connection.config
    }
  }
  throw new Error(`No controller connection with role "${role}".`)
}
